function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import * as api from "./sequences-api";
import { isCard, isMedia, cardStyle, thumbOf, captionLine, fmtLen } from "./sequence-common";

/*
 * The stage of the sequence editor: one scene in the chosen size on the grey backdrop, the safe area dashed, the
 * words on screen and the caption line inside it, and a "Scene N · length" chip. While Play all runs, a clip scene
 * plays muted from its trim start. It is a preview: the real render adds motion, music and smooth transitions.
 */

const ASPECT = {
  "16:9": 16 / 9,
  "9:16": 9 / 16,
  "1:1": 1
};
/** Width that keeps the frame inside the stage at any size (height capped like the image editor). */
export const frameWidth = format => `min(100%, calc(${(ASPECT[format] || 16 / 9).toFixed(4)} * min(400px, 50vh)))`;
class StageVideo extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ref", /*#__PURE__*/React.createRef());
    _defineProperty(this, "seek", () => {
      const v = this.ref.current;
      if (!v) return;
      const go = () => {
        try {
          v.currentTime = Number(this.props.start) || 0;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        } catch (e) {/* no-op */}
      };
      if (v.readyState >= 1) go();else v.onloadedmetadata = go;
    });
  }
  componentDidMount() {
    this.seek();
  }
  componentDidUpdate(prev) {
    if (prev.src !== this.props.src) this.seek();
  }
  render() {
    return /*#__PURE__*/React.createElement("video", {
      ref: this.ref,
      src: this.props.src,
      muted: true,
      playsInline: true,
      preload: "auto",
      className: this.props.contain ? "contain" : ""
    });
  }
}
export function SceneFrame({
  seg,
  idx,
  format,
  captions,
  brand,
  len,
  playing
}) {
  const safe = api.SAFE[format] || api.SAFE["16:9"];
  const accent = brand && brand.accent || "#1d4ed8";
  const contain = seg && (seg.kind === "recording" || seg.fit === "contain");
  const thumb = thumbOf(seg);
  let media;
  if (!seg) media = /*#__PURE__*/React.createElement("span", {
    className: "sx-empty"
  }, "No scenes yet. Add one from Assets, or rewrite the cut.");else if (isCard(seg)) {
    const end = cardStyle(seg, idx) === "end";
    media = /*#__PURE__*/React.createElement("div", {
      className: "sx-cardface" + (end ? " end" : ""),
      style: end ? undefined : {
        background: `linear-gradient(135deg, ${accent}, #1c1f24)`
      }
    }, /*#__PURE__*/React.createElement("b", null, seg.card && seg.card.headline || (end ? "End card" : "Title card")), seg.card && seg.card.sub ? /*#__PURE__*/React.createElement("span", null, seg.card.sub) : null);
  } else if (playing && isMedia(seg) && seg.mediaUrl) media = /*#__PURE__*/React.createElement(StageVideo, {
    src: seg.mediaUrl,
    start: seg.trimStart,
    contain: contain
  });else if (thumb) media = /*#__PURE__*/React.createElement("img", {
    src: thumb,
    alt: seg.title || "",
    draggable: false,
    className: contain ? "contain" : ""
  });else if (seg.mediaUrl && isMedia(seg)) media = /*#__PURE__*/React.createElement("video", {
    src: seg.mediaUrl,
    muted: true,
    playsInline: true,
    preload: "metadata",
    className: contain ? "contain" : ""
  });else media = /*#__PURE__*/React.createElement("span", {
    className: "sx-empty"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, isMedia(seg) ? "movie" : "image"), "This scene has no picture yet");
  const words = seg && !isCard(seg) ? String(seg.overlayText || "").trim() : "";
  const capt = captions && seg && !isCard(seg) && seg.narration ? captionLine(seg.narration) : "";
  return /*#__PURE__*/React.createElement("div", {
    className: "sx-frame f" + format.replace(":", ""),
    style: {
      aspectRatio: api.aspectOf(format),
      width: frameWidth(format)
    }
  }, media, seg ? /*#__PURE__*/React.createElement("div", {
    className: "sx-safe",
    style: {
      left: `${safe.l * 100}%`,
      right: `${safe.r * 100}%`,
      top: `${safe.t * 100}%`,
      bottom: `${safe.b * 100}%`
    },
    "aria-hidden": "true"
  }) : null, words ? /*#__PURE__*/React.createElement("span", {
    className: "sx-words",
    style: {
      bottom: `${(safe.b + (capt ? 0.075 : 0.02)) * 100}%`,
      maxWidth: `${(1 - safe.l - safe.r) * 100}%`,
      ...(brand && brand.accent ? {
        boxShadow: `inset 0 -3px 0 ${brand.accent}`
      } : {})
    }
  }, words) : null, capt ? /*#__PURE__*/React.createElement("span", {
    className: "sx-capt",
    style: {
      bottom: `${(safe.b + 0.01) * 100}%`,
      maxWidth: `${(1 - safe.l - safe.r - 0.04) * 100}%`
    }
  }, capt) : null, seg && seg.chapterTitle ? /*#__PURE__*/React.createElement("span", {
    className: "sx-chap"
  }, seg.chapterTitle) : null, seg ? /*#__PURE__*/React.createElement("span", {
    className: "sx-chip"
  }, "Scene ", idx + 1, " \xB7 ", fmtLen(len)) : null);
}

/** A finished export on the stage (Exports tab, click a ready size). */
export function ExportStage({
  render,
  name,
  stale,
  onClose
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "sx-watch"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sx-watchcap"
  }, /*#__PURE__*/React.createElement("b", null, name), " \xB7 the finished video \xB7 ", api.fmtClock(render.durationSeconds)), /*#__PURE__*/React.createElement("div", {
    className: "sx-frame player",
    style: {
      aspectRatio: api.aspectOf(render.format),
      width: frameWidth(render.format)
    }
  }, /*#__PURE__*/React.createElement("video", {
    key: render.id,
    src: render.url,
    poster: render.posterUrl || undefined,
    controls: true,
    playsInline: true,
    preload: "metadata"
  })), /*#__PURE__*/React.createElement("span", {
    className: "sx-watchnote"
  }, stale ? "This file is older than the storyboard. " : "", "Edits made after a render show up on the next Render. These files stay as they are."), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "sx-btn",
    onClick: onClose
  }, "Back to the storyboard"));
}